var Dom = new (class Dom extends AbstractModule {

  constructor() {
    super("Dom");

    this.widget_displayed        = false;
    this._tab_active             = null;
    this._tab_visible            = null; // null => unsupported
    this._file_sharing_displayed = true;
    this._current_send_button    = 'file';
    this._current_footer         = undefined;
    this._components             = {};
    this._ios_scroll_fix_backup  = {};
    this.customCss               = {};
    this.componentsProps         = {};
    this._offset_from_edge       = 20; // Also defined in positions.css.scss

    this._previousHeight = 670;
    this._previousWidth = 368;
    this._previousKind = 'small';
    this._forcedLarge = false;

    if (this.isInIframe())
      this.parent = window.parent;
    else
      this.parent = window;

    this._externalCss = `GULP-CSS-EXTERNAL`; // CSS is external in chat_debug.js (boolean)
    this._css = { // string
      all: `GULP-CSS-FILE-ALL`,
      positions: `GULP-CSS-FILE-POSITIONS`,
      parent: `GULP-CSS-FILE-PARENT`
    };
  }

  _initAfterWidget(widgetData) {
    const globalHide = widgetData.hide_slaask_button;
    const hideFromSnippet = this.app._hide_slaask_button_option;
    const hideOnMobile = widgetData.hide_on_mobile && this.app.getScreenWidth() < this.app._mobile_threshold;
    this.hide_slaask_button = globalHide || hideFromSnippet || hideOnMobile;
    this._initEventHandlers();
  }

  _initEventHandlers() {

    /* RESIZE */

    const onResize = () => {
      this.updateMobileClass();
      this.updateFooterSize();
    };
    this._registerEvent(this.parent, 'resize', onResize);

    /* FOCUS */

    let onBlur = () => {
      if (this._tab_active !== false) {
        this._tab_active = false;
        this._trigger('tab-blur');
      }
    };
    let onFocus = () => {
      if (this._tab_active !== true) {
        this._tab_active = true;
        this._trigger('tab-focus');
      }
    };
    this._registerEvent(this.parent, 'blur', onBlur);
    this._registerEvent(this.parent, 'focus', onFocus);
    if (this.parent.document.hasFocus()) onFocus();
    else onBlur();
    this.get('widget').when('ready').then(() => {
      this._registerEvent(this.get('widget').window, 'blur', onBlur);
      this._registerEvent(this.get('widget').window, 'focus', onFocus);
    });
    let onClick = () => {
      if (this._tab_active !== true) {
        this._tab_active = true;
        this._trigger('tab-focus');
      }
      this._unregisterEvent(this.parent, 'click', onClick);
    };
    this._registerEvent(this.parent, 'click', onClick);

    /* VISIBILITY */

    if (typeof document.hidden !== "undefined") {
      const onVisibilityChange = () => {
        this._tab_visible = !document.hidden;
        if (this._tab_visible) this._trigger('tab-visible');
        else this._trigger('tab-hidden');
      };
      this._registerEvent(this.parent.document, 'visibilitychange', onVisibilityChange);
      onVisibilityChange();
    }

    /* POPUP */

    this.app.on('close', () => {
      if (this.parent.asktechWidgetPopup) {
        this.parent.close();
      }
    });
  }

  /* SHOW / HIDE */

  /**
   * @param {Object} options
   * @param {string} [options.by] Tells what actually opened the chatbox
   * @param {string} [options.view] Opens the widget on a given View
   * @param {string} [options.state] Opens the given View with the given State
   * @param {string} [options.message] Updates the chat input with a given string
   * @param {boolean=false} force_open Forces the opening script event if the
   *  widget is already open
   */
  async showWidget(options = {}, force_open = false) {
    let popupOpened = false;
    if (this.app._open_in_popup) {
      popupOpened = await this.openPopup.apply(this, arguments);
    }

    if (!popupOpened) {
      await this.app.when('ready');
      await Promise.all([
        this.get('widget').buildIfNeeded(),
        this.get('gradient').buildIfNeeded()
      ]);

      if ((options.by == 'button_click' || options.by == 'user') && !Homepage.skipsToConversationsOnly()) {
        Conversations.userCommittedToNewConversation();
      }

      if (options.view) {
        Views.jumpToViewByName(options.view, options.state);
      }

      if (!this.widget_displayed || force_open) {
        if (this.app._is_iphone) {
          // this.app._previously_scrolled_top = this.parent.document.body.scrollTop;
          this._ios_scroll_fix_backup['body'] = this.parent.document.body.scrollTop;
          this._ios_scroll_fix_backup['html'] = this.parent.document.querySelector('html').scrollTop;
          this.addClass('parent', 'body', 'slaask-fixed');
        }

        if (options.by) {
          this.app._triggerInternalEvent('open', { 'by': options.by });
        } else {
          this.app._triggerInternalEvent('open', { 'by': null });
        }

        Notifier.removeAllBubbles();

        if (options.message) {
          this.updateInputValue(options.message);
        }

        if (this.hide_slaask_button) {
          this.removeClass('button', 'slaask-hidden');
        }

        this.addClass('button', 'slaask-opened');

        if(this.app._mini_widget && (this.app._x_offset === 0 && this.app._y_offset === 0)) { this.removeClass('gradient', 'slaask-hidden'); }
        const animateMiniOpen = this.app._mini_widget && !this._miniWidgetOpenedOnce && options.animate !== false;
        if (this.app._mini_widget) this._miniWidgetOpenedOnce = true;

        if (animateMiniOpen) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.removeClass('widget', 'slaask-hidden');
              this.updateFooterSize();
            });
          });
        } else if (this.app._mini_widget && options.animate === false) {
          const widget = this.get('widget').element;
          widget.style.transition = 'none';
          this.removeClass('widget', 'slaask-hidden');
          requestAnimationFrame(() => { widget.style.transition = ''; });
        } else {
          this.removeClass('widget', 'slaask-hidden');
        }

        this._setTimeout(() => {
          this.addClass('widget', 'slaask-widget-loaded');
        }, 1000);

        // if(!this._isVisible('slaask-whitelabel')) {
        // if (false) {
        //   this.get('button').addClass('slaask-hidden');
        //   this.get('widget').addClass('slaask-hidden');

        //   console.log("\n\nHey " + this._support_name + " " + EmojiMap.wave + " !\n\nUnfortunately, your widget detected that you are hiding our branding right below the message input, and that's why your widget is blocked " + EmojiMap.no_entry_sign + ".\n\nJust remove the code hiding the widget, and everything will come back to normal.\n\nIf you didn't changed anything, just contact us on https://slaask.com#chat-open " + EmojiMap.ok_hand + ".\n\nYou want to remove our branding on your widget? Visit https://slaask.com/pricing and pick a Pro plan " + EmojiMap["+1"] + " !\n\n\n")
        // }

        this.widget_displayed = true
        this.updateFooterSize();
        this.app._subscribeToChannel();
        this._trigger('open');
        this._eventHappened('opened-once');
      } else {
        if (options.message) {
          this.updateInputValue(options.message);
        }
      }

      if (this.app.isLive()){
        if(this.app.getScreenWidth() >= this.app._mobile_threshold) {
          this.focusInput()
        }
        let prechatQuestionInput = this.findById('widget', 'slaask-prechat-question-input');
        if(prechatQuestionInput) { prechatQuestionInput.focus(); }
        this.updateInputSize();
      } else {
        let emailInput = this.findById('widget', 'slaask-email-input');
        if (emailInput) {
          if (emailInput.value) {
            this.findById('widget', 'slaask-offline-message-input').focus();
          } else {
            emailInput.focus();
          }
        }
      }
    }
  }

  show() {
    Utils.warn("Dom.show() is deprecated. Please use Dom.showWidget() instead.");
    return this.showWidget.apply(this, arguments);
  }

  hideWidget(options) {
    if(this.widget_displayed) {
      if (this.app._nativeSdk) {
        window.location.hash = 'closeButtonPressed'
        window.location.href = this.app._guessBrand() + '://closeButtonPressed'
        return
      }

      if (this.app._is_iphone) {
        this.removeClass('parent', 'body', 'slaask-fixed');
        // this.parent.document.body.scrollTop = this.app._previously_scrolled_top
        this.parent.document.body.scrollTop = this._ios_scroll_fix_backup['body'];
        this.parent.document.querySelector('html').scrollTop = this._ios_scroll_fix_backup['html'];
      }

      if(this.app.getScreenWidth() >= this.app._mobile_threshold) {
        this.findById('widget', 'slaask-input').blur();
      }

      if (this.hide_slaask_button) {
        this.addClass('button', 'slaask-hidden');
      }

      this.addClass('widget', 'slaask-hidden');
      if (this.app._mini_widget) this.addClass('gradient', 'slaask-hidden');
      this.removeClass('widget', 'slaask-widget-loaded');
      this.removeClass('button', 'slaask-opened');
      if (typeof options != 'undefined' && typeof options.by != 'undefined') {
        this.app._triggerInternalEvent('close', { 'by': options.by });
      } else {
        this.app._triggerInternalEvent('close', { 'by': null });
      }

      this.widget_displayed = false
    }
  }

  hide() {
    Utils.warn("Dom.hide() is deprecated. Please use Dom.hideWidget() instead.");
    return this.hideWidget.apply(this, arguments);
  }

  /**
   * To make this function being able to recover focus on some browsers (Firefox),
   * please make sure of the following conditions:
   * - The function is called by a user interaction (from a 'click' listener)
   * - The function is called synchronously (no await usage between the click and the function)
   * - The handler function bind to the interaction event (click) must be
   *   declared from the parent frame. You can use the appLoader.proxy(callback) function
   *   to achieve this.
   *
   * @param  {Object} options Same options as showWidget
   * @return {Boolean}        Whether the popup could be opened or not
   */
  async openPopup(options) {
    let popup = new Popup(this.parent, this.app);
    if (popup.isSupported()) {
      await popup.open(options);
      return true;
    }
    else return false;
  }

  /**
   * Note: Returns null if the feature is not supported by the browser
   * @return {Boolean}
   */
  isTabVisible() {
    return this._tab_visible;
  }

  /* INPUT */

  get headerHeight() {
    return this.findById('widget', 'slaask-widget-header').offsetHeight;
  }

  get widgetHeight() {
    return this.get('widget').element.offsetHeight;
  }

  initAutoSize() {
    this.when('opened-once', () => {
      let input = this.findById('widget', 'slaask-input');
      if (input) {
        window.autosize(input);
        input.addEventListener('autosize:resized', () => {
          this.updateFooterSize();
        });
        this._eventHappened('autosize-initialized')
        this.updateFooterSize()
      }
    });
  }

  get _footer_enabled() { return this._current_footer == 'footer'; }
  get _input_enabled() { return this._current_footer == 'input'; }
  get _get_started_enabled() { return this._current_footer == 'get_started'; }

  switchFooter(elementName) {
    if (!~[null, 'footer', 'input', 'get_started'].indexOf(elementName)) {
      throw "There is no footer with elementName: " + elementName;
    }

    if (this._current_footer == elementName) return;

    if (this.get('widget').isReady()) {
      // Footer
      if (elementName == 'footer') {
        this.removeClass('widget', '#slaask-widget-footer', 'slaask-footer-hidden');
        this.findById('widget', 'slaask-widget-footer').style.display = '';
      }
      else {
        this.addClass('widget', '#slaask-widget-footer', 'slaask-footer-hidden');
        this.findById('widget', 'slaask-widget-footer').style.display = 'none';
      }

      // Input
      let input = this.findById('widget', 'slaask-input');
      if (elementName == 'input') {
        this.removeClass('widget', '#slaask-form', 'slaask-form-hidden');
        this.findById('widget', 'slaask-form').style.display = '';
        this.findById('widget', 'slaask-form').setAttribute('aria-hidden', 'false');
        if (Utils.isIe9) input.style.display = '';
        this.updateInputSize();
        if (!this.app._is_touch) {
          // Focus input during transition causes unexpected scroll from the non-scrolling main element
          this._setTimeout(() => {
            this.focusInput();
          }, Views.getMoverTransitionDuration());
        }
      }
      else {
        this.addClass('widget', '#slaask-form', 'slaask-form-hidden');
        this.findById('widget', 'slaask-form').style.display = 'none';
        this.findById('widget', 'slaask-form').setAttribute('aria-hidden', 'true');
        input.blur();
        if (Utils.isIe9) input.style.display = 'none';
      }

      // Get started
      if (elementName == 'get_started') {
        this.removeClass('widget', '#asktech-get-started', 'asktech-hidden');
      }
      else {
        this.addClass('widget', '#asktech-get-started', 'asktech-hidden');
      }

      this._current_footer = elementName;
      this.updateFooterSize();
    }
  }

  focusInput() {
    if (this._input_enabled) this.findById('widget', 'slaask-input').focus();
  }

  updateFooterSize() {
    if (this.didEventHappen('autosize-initialized')) {
      // Init
      let input                   = this.findById('widget', 'slaask-input');
      let footer                  = this.findById('widget', 'slaask-widget-footer');
      let getStarted              = this.findById('widget', 'asktech-get-started');
      let container               = this.findById('widget', 'slaask-widget-views-container');
      let emoji                   = this.findById('widget', 'slaask-emoji-container');
      let gifs                    = this.findById('widget', 'slaask-gifs-container');
      let whitelabel              = this.findById('widget', 'slaask-whitelabel');
      let menu                    = this.findById('widget', 'slaask-file-menu');
      let inputEnabled            = this._input_enabled;
      let footerEnabled           = this._footer_enabled;
      let getStartedEnabled       = this._get_started_enabled;
      let height                  = {};

      // Footer
      height.whitelabel           = Utils.computedOuterHeight(whitelabel);
      height.footer               = (height.whitelabel) * footerEnabled;

      // Form
      height.input                = Utils.computedOuterHeight(input);
      height.form                 = (height.input) * inputEnabled;

      // Get started
      height.getStarted           = Utils.computedOuterHeight(getStarted) * getStartedEnabled;

      // Edit styles
      container.style.height      = (this.widgetHeight - this.headerHeight - height.footer - height.form - height.getStarted) + 'px';
      emoji.style.bottom          = (height.form) + 'px';
      gifs.style.bottom           = (height.form) + 'px';
      if (menu) menu.style.bottom = (height.form) + 'px';

      // Scroll if needed
      if (Views.current.name == 'conversation') {
        Conversations.keepScrollOnBottom();
      }
    }
  }

  updateMobileClass() {
    const widget = this.get('widget');
    if (!widget || !widget.element) return;

    const isMobile = this.app.getScreenWidth() < this.app._mobile_threshold;

    if (isMobile) {
      this.addClass('widget', 'slaask-mobile');
      this.removeClass('widget', 'slaask-mini');
    }
    else {
      this.removeClass('widget', 'slaask-mobile');
      this.addClass('widget', 'slaask-mini');
    }

    this.updateZoomButtons();
  }

  // Zoom is meaningless on mobile or when the size is forced to full / veryLarge.
  updateZoomButtons() {
    const widget = this.get('widget');
    if (!widget || !widget.element) return;

    const zoomInButton = this.findById('widget', 'slaask-widget-header-zoom-in');
    const zoomOutButton = this.findById('widget', 'slaask-widget-header-zoom-out');
    if (!zoomInButton || !zoomOutButton) return;

    const isMobile = this.app.getScreenWidth() < this.app._mobile_threshold;
    const display = isMobile || this._previousKind === 'full' || this._previousKind === 'veryLarge' ? 'none' : '';

    zoomInButton.style.display = display;
    zoomOutButton.style.display = display;
  }

  updateInputSize() {
    var evt = document.createEvent('Event');
    evt.initEvent('autosize:update', true, false);
    this.findById('widget', 'slaask-input').dispatchEvent(evt);
  }

  updateInputValue(text) {
    this.findById('widget', 'slaask-input').value = text;
    Utils.localStorage('typed-text', text);
    this.updateInputSize();
    this.updateSendButton();
  }

  updateSendButton() {
    let input = this.findById('widget', 'slaask-input');
    if (input.value.trim() != '') this.showSendButton();
    else this.showFileSharingButton();
  }

  /**
   * @param {'full' | 'veryLarge' | 'large' | 'small'} kind
   * @param {Function} callback
   * @param {boolean} force Keep this size across view changes. `large` stays until a forced `small`.
   */
  setWidgetSize(kind, callback, force = false) {
    let parentWidget = this.parent.document.querySelector('#slaask-widget');

    if (kind == this._previousKind) {
      if (force) this._forcedLarge = kind === 'large';
      if (callback) callback();

      return;
    }

    // full, veryLarge, and a forced large stay until an explicit forced resize.
    const sizeIsForced = this._previousKind === 'full' || this._previousKind === 'veryLarge' || this._forcedLarge;

    if (sizeIsForced && !force) {
      if (callback) callback();

      return;
    }

    if (force) {
      this._forcedLarge = kind === 'large';
    }

    const fromKind = this._previousKind;
    this._previousKind = kind;
    this.updateZoomButtons();
    
    if (kind == 'full') {
      if (!parentWidget) {
        this.showWidget({ by: 'setWidgetSize' });
      }

      this.when('opened-once').then(() => {
        parentWidget = this.parent.document.querySelector('#slaask-widget');

        this._previousWidth = `${parentWidget.clientWidth}px`;
        this._previousHeight = `${parentWidget.clientHeight}px`;
  
        parentWidget.style.maxHeight = '100%';
        parentWidget.style.transition = 'width 200ms, height 200ms';
        parentWidget.style['will-change'] = 'width, height';
        parentWidget.style.width = '100%';
        parentWidget.style.height = '100%';
        parentWidget.style.bottom = '0';
        parentWidget.style.right = '0';
        parentWidget.style.left = '0';
        parentWidget.style.borderRadius = '0';
  
        this.findById('widget', 'slaask-widget-views-container').style['min-height'] = '100%';
        this.findById('widget', 'slaask-widget-views-mover').style['max-width'] = '1280px';
        this.findById('widget', 'slaask-widget-views-mover').style['margin'] = 'auto';
  
        this.findById('widget', 'asktech-get-started').style['max-width'] = '1280px';
  
        this.findById('widget', 'slaask-widget-header').style['padding'] = '0 calc((100% - 1280px) / 2)';
        this.findById('widget', 'slaask-widget-header').style['box-sizing'] = 'border-box';
  
        this.findById('widget', 'slaask-widget-header-title').style.setProperty('width', 'calc(100% - 148px)', 'important');
  
        this.findById('widget', 'slaask-widget-header-cross').style.setProperty('display', 'none', 'important');
  
        setTimeout(() => {
          this.updateFooterSize();
          this.findById('widget', 'slaask-widget-views-container').style['min-height'] = 'auto';
          if (callback) callback();
        }, 250)
      });
    } else if (kind == 'veryLarge') {
      this._previousWidth = `${parentWidget.clientWidth}px`;
      this._previousHeight = `${parentWidget.clientHeight}px`;

      parentWidget.style.maxHeight = parentWidget.style.maxHeight || this.parent.window.getComputedStyle(parentWidget).maxHeight;
      parentWidget.style.transition = 'width 200ms, height 200ms';
      parentWidget.style['will-change'] = 'width, height';
      parentWidget.style.width = '100%';
      parentWidget.style.height = parentWidget.style.maxHeight;
      parentWidget.style.right = '0';
      parentWidget.style.left = '0';
      parentWidget.style.borderRadius = '0';

      this.findById('widget', 'slaask-widget-views-container').style['min-height'] = '100%';
      this.findById('widget', 'slaask-widget-views-mover').style['max-width'] = '1280px';
      this.findById('widget', 'slaask-widget-views-mover').style['margin'] = 'auto';

      this.findById('widget', 'asktech-get-started').style['max-width'] = '1280px';

      this.findById('widget', 'slaask-widget-header').style['padding'] = '0 calc((100% - 1280px) / 2)';
      this.findById('widget', 'slaask-widget-header').style['box-sizing'] = 'border-box';

      this.findById('widget', 'slaask-widget-header-title').style.setProperty('width', 'calc(100% - 148px)', 'important');
      this.findById('widget', 'slaask-widget-header-cross').style.removeProperty('display');

      setTimeout(() => {
        this.updateFooterSize();
        this.findById('widget', 'slaask-widget-views-container').style['min-height'] = 'auto';
        if (callback) callback();
      }, 250)
    } else if (kind == 'large') {
      this._previousWidth = `${parentWidget.clientWidth}px`;
      this._previousHeight = `${parentWidget.clientHeight}px`;

      parentWidget.style.transition = 'width 200ms ease 0s, height 200ms ease 0s';
      parentWidget.style['will-change'] = 'width, height';

      parentWidget.style['width'] = '688px';

      parentWidget.style['height'] = parentWidget.style['max-height'] || this.parent.window.getComputedStyle(parentWidget).maxHeight;

      this.findById('widget', 'slaask-widget-views-container').style['min-height'] = '100%';

      this.findById('widget', 'slaask-widget-header-title').style.setProperty('width', 'calc(100% - 148px)', 'important');

      setTimeout(() => {
        this.updateFooterSize();
        this.findById('widget', 'slaask-widget-views-container').style['min-height'] = 'auto';
        if (callback) callback();
      }, 250)
    } else {
      
      parentWidget.style['width'] = this._previousWidth;
      parentWidget.style['height'] = this._previousHeight;

      setTimeout(() => {
        this.updateFooterSize();
        if (callback) callback();
      }, 250)
    }
  }

  showSendButton() {
    this.get('widget').when('ready').then(() => {
      this.removeClass('widget', '#slaask-send-input-trigger', 'slaask-hidden');
      this.addClass('widget', '#slaask-paperclip', 'slaask-hidden');
      this.addClass('widget', '#slaask-gifs-button', 'slaask-button-hidden');
    });
    this._current_send_button = 'send';
  }

  showFileSharingButton() {
    if (this.menuHasOneFeature() && this._file_sharing_displayed) {
      this.get('widget').when('ready').then(() => {
        this.addClass('widget', '#slaask-send-input-trigger', 'slaask-hidden');
        this.removeClass('widget', '#slaask-paperclip', 'slaask-hidden');
        this.removeClass('widget', '#slaask-gifs-button', 'slaask-button-hidden');
      });
      this._current_send_button = 'file';
    }
    else {
      this.removeClass('widget', '#slaask-gifs-button', 'slaask-button-hidden');
      this.showEmptyButton();
    }
  }

  menuHasOneFeature() {
    return this.app._file_sharing_activated || this.app._videochat_enabled || this.app._sendscreenshot_enabled || this.app._chattranscript_enabled || this.app._ephemeral_conversations_enabled;
  }

  showEmptyButton() {
    this.get('widget').when('ready').then(() => {
      this.addClass('widget', '#slaask-send-input-trigger', 'slaask-hidden');
      this.addClass('widget', '#slaask-paperclip', 'slaask-hidden');
    });
    this._current_send_button = 'empty';
  }


  toggleFileSharingDisplay(enabled = true) {
    this._file_sharing_displayed = enabled;
    if (!enabled && this._current_send_button == 'file') {
      this.showEmptyButton();
    }
    else if (enabled && this._current_send_button == 'empty') {
      this.showFileSharingButton();
    }
  }

  /* FILE SHARING */

  showConversationMenu() {
    this.addClass('widget', '#slaask-file-menu', 'slaask-opened');
    this.findById('widget', 'slaask-file-menu').setAttribute('aria-hidden', 'false');
    this.findById('widget', 'slaask-file-menu').style.display = '';
    this.findById('widget', 'slaask-file-menu').style.visibility = 'visible';

    const ephemeralBtn = this.findById('widget', 'slaask-file-btn-ephemeral');
    if (ephemeralBtn) {
      if (Conversations.current && Conversations.current.ephemeral) {
        ephemeralBtn.classList.add('slaask-hidden');
      } else {
        ephemeralBtn.classList.remove('slaask-hidden');
      }
    }

    let handler = (event) => {
      if (event.target.id != "slaask-paperclip" && !event.target.closest('#slaask-file-menu')) {
        this.hideConversationMenu();
      }
    };
    this._registerEvent(this.get('widget').element, 'click', handler);
    this.once('conversation-menu-hidden', () => {
      this._unregisterEvent(this.get('widget').element, 'click', handler);
    });
    this._trigger('conversation-menu-shown');
  }

  hideConversationMenu() {
    this.removeClass('widget', '#slaask-file-menu', 'slaask-opened');
    this.findById('widget', 'slaask-file-menu').setAttribute('aria-hidden', 'true');
    this.findById('widget', 'slaask-file-menu').style.display = 'none';
    this.findById('widget', 'slaask-file-menu').style.visibility = 'hidden';
    this._trigger('conversation-menu-hidden');
  }

  _syncHeaderEphemeralButton() {
    const headerEphemeralBtn = this.findById('widget', 'slaask-widget-header-ephemeral');
    if (!headerEphemeralBtn) return;
    const inConversation = Views.current && Views.current.name === 'conversation' && Conversations.current;
    const show = this.app._ephemeral_conversations_enabled && inConversation && !Conversations.current.ephemeral;
    if (show) {
      headerEphemeralBtn.classList.remove('slaask-hidden');
    } else {
      headerEphemeralBtn.classList.add('slaask-hidden');
    }
  }

  /**
   * @param {Record<string, boolean>} features
   */
  toggleConversationMenuFeatures(features) {
    Object.keys(features).forEach(featureName => {
      const enabled = features[featureName];
      this._toggleConversationMenuFeature(featureName, enabled)
    });
  }

  /**
   * @param {string} featureName
   * @param {boolean} enabled
   */
  _toggleConversationMenuFeature(featureName, enabled) {
    const selector = '#slaask-file-btn-' + featureName;
    if (enabled) {
      this.removeClass('widget', selector, 'disabled');
      if (featureName === 'transcript') this.removeClass('widget', selector, 'slaask-hidden');
    }
    else {
      this.addClass('widget', selector, 'disabled');
      if (featureName === 'transcript') this.addClass('widget', selector, 'slaask-hidden');
    }
  }


  /* EMOJI CONTAINER */

  toggleEmojiContainer() {
    if (this.hasClass('widget', '#slaask-emoji-container', 'slaask-emoji-container-hidden')) {
      this.showEmojiContainer();
    }
    else {
      this.hideEmojiContainer();
    }
  }

  showEmojiContainer() {
    if (Utils.isIe9) this.removeClass('widget', '#slaask-emoji-container', 'slaask-hidden');
    this.removeClass('widget', '#slaask-emoji-container', 'slaask-emoji-container-hidden');
    this.findById('widget', 'slaask-emoji-container').setAttribute('aria-hidden', 'false');
    this.findById('widget', 'slaask-emoji-container').style.display = '';
    this.findById('widget', 'slaask-emoji-container').style.visibility = 'visible';

    this.removeClass('widget', '#slaask-menu-background-closer', 'slaask-hidden');
    this.findById('widget', 'slaask-menu-background-closer').setAttribute('aria-hidden', 'false');

    this._setTimeout(() => {
      EmojiPicker.filterBy('', true);
      this.findById('widget', 'slaask-emojis-input').focus();
    }, 100)
  }

  hideEmojiContainer() {
    if (Utils.isIe9) this.addClass('widget', '#slaask-emoji-container', 'slaask-hidden');
    this.addClass('widget', '#slaask-emoji-container', 'slaask-emoji-container-hidden');
    this.findById('widget', 'slaask-emoji-container').setAttribute('aria-hidden', 'true');
    this.findById('widget', 'slaask-emoji-container').style.display = 'none';
    this.findById('widget', 'slaask-emoji-container').style.visibility = 'hidden';

    this.addClass('widget', '#slaask-menu-background-closer', 'slaask-hidden');
    this.findById('widget', 'slaask-menu-background-closer').setAttribute('aria-hidden', 'true');

    this.focusInput();

    this._setTimeout(() => {
      this.findById('widget', 'slaask-emojis-input').value = ''
      EmojiPicker.filterBy('')
    }, 300)
  }

  /* GIFS CONTAINER */

  toggleGifsContainer() {
    if (this.hasClass('widget', '#slaask-gifs-container', 'slaask-gifs-container-hidden')) {
      this.showGifsContainer();
    }
    else {
      this.hideGifsContainer();
    }
    this.focusInput();
  }

  showGifsContainer() {
    if (Utils.isIe9) this.removeClass('widget', '#slaask-gifs-container', 'slaask-hidden');
    this.removeClass('widget', '#slaask-gifs-container', 'slaask-gifs-container-hidden');
    this.findById('widget', 'slaask-gifs-container').setAttribute('aria-hidden', 'false');
    this.findById('widget', 'slaask-gifs-container').style.display = '';
    this.findById('widget', 'slaask-gifs-container').style.visibility = 'visible';

    this.removeClass('widget', '#slaask-menu-background-closer', 'slaask-hidden');
    this.findById('widget', 'slaask-menu-background-closer').setAttribute('aria-hidden', 'false');

    Gifs.display('featured');

    this._setTimeout(() => {
      this.findById('widget', 'slaask-gifs-input').focus();
    }, 100)
  }

  hideGifsContainer() {
    if (Utils.isIe9) this.addClass('widget', '#slaask-gifs-container', 'slaask-hidden');
    this.addClass('widget', '#slaask-gifs-container', 'slaask-gifs-container-hidden');
    this.findById('widget', 'slaask-gifs-container').setAttribute('aria-hidden', 'true');
    this.findById('widget', 'slaask-gifs-container').style.display = 'none';
    this.findById('widget', 'slaask-gifs-container').style.visibility = 'hidden';

    this.addClass('widget', '#slaask-menu-background-closer', 'slaask-hidden');
    this.findById('widget', 'slaask-menu-background-closer').setAttribute('aria-hidden', 'true');

    this.focusInput();
  }

  gifSearchQueryChanged() {
    Gifs.display('search', this.findById('widget', 'slaask-gifs-input').value)
  }

  /* DOM */

  mainTitle(html) {
    if (typeof html == "object") html = html.outerHTML;
    let element = this.findById('widget', 'slaask-widget-header-title-main');
    if (Utils.exists(html)) element.innerHTML = this.app._askTechParser.Emoji.emojify(html);
    return element.innerHTML;
  }

  smallTitle(html) {
    if (typeof html == "object") html = html.outerHTML;
    let element = this.findById('widget', 'slaask-widget-header-title-small');
    if (Utils.exists(html)) {
      const titleEl = this.findById('widget', 'slaask-widget-header-title');
      element.innerHTML = this.app._askTechParser.Emoji.emojify(html);
      if (element.innerHTML.length == 0) {
        Utils.addClass(titleEl, 'no-small-title')
      }
      else Utils.removeClass(titleEl, 'no-small-title')
    }
    return element.innerHTML;
  }

  async appendToDom() {

    // Hide iframes
    let cssHideIframesTag = await Utils.appendCss(this.parent.document, '.slaask-component { display: none!important; }');

    /* INIT VARS */

    let props = {};
    let computedYOffset = (this.app.getScreenWidth() > this.app._mobile_threshold) ? this.app._y_offset : 0
    if (this.app._y_offset !== 0 && this.app.getScreenWidth() > this.app._mobile_threshold) {
      computedYOffset -= this._offset_from_edge
    }
    if (this.app._full_width_button) {
      props.buttonImage = this.app._message_displayed_image
      props.buttonStyle = 'background-size: 104% 104%!important;background-image: url(' + props.buttonImage + ');'
    } else {
      props.buttonShape = Svg.slaask(this.app._window_color)
      props.buttonStyle = 'background-image: url(data:image/svg+xml;base64,' + window.btoa(props.buttonShape) + ');background-color:#fff;background-size: 106% 106%!important;'
    }

    if (this.app.isLive()) {
      props.inputModuleClass  = ''
      props.placeholder       = Wording.online_input_content
    } else {
      props.inputModuleClass  = 'slaask-search-input'
      props.placeholder       = Wording.bot_input_text
    }

    props.side =  (this.app._widget_left)
                  ? "left"
                  : "right";

    props.sideClass = (this.app._widget_left)
                      ? "slaask-left"
                      : "";

    props.nativeSdk = (this.app._nativeSdk)
                      ? "slaask-embedded-widget"
                      : "";

    props.rtl = (this.app._direction == 'rtl')
                ? 'rtl'
                : '';

    props.backgroundStyle = '';

    if (this.app._pattern_image)
      props.backgroundStyle += ' background-image: url(' + this.app._pattern_image + '); background-repeat: repeat;'

    props.gifButton = `
                        <div class="slaask-gifs-button ${this.app._hide_emoji_button ? 'slaask-gifs-button-right' : ''} slaask-file-input-trigger" style="color: #888da8;font-size: 14px;font-weight: bold;" id="slaask-gifs-button">
                          GIF
                        </div>`;

    if (this.app._hide_gif_button) props.gifButton = ''

    props.emojiButton = `
                          <div class="slaask-emoji-button slaask-file-input-trigger" id="slaask-emoji-button">
                            ${Svg.emoji()}
                          </div>`;

    if (this.app._hide_emoji_button) props.emojiButton = ''

    props.fileSharingMenu = '';
    props.fileSharingButton = '';

    if (this.menuHasOneFeature()) {
      props.fileSharingMenu = `
                              <div id="slaask-file-menu" class="slaask-file-menu">
                                <div id="slaask-file-btns" class="slaask-file-btns"></div>
                              </div>`;

      props.fileSharingButton = `<div class="slaask-file-input-trigger" style="background-image: url(${this.app._cdn_url}/more-vertical.svg);" id="slaask-paperclip"></div>`;
    }

    props.sendMessageHtml = '<div class="slaask-file-input-trigger slaask-hidden" style="background-image: url(' + this.app._cdn_url + '/send.svg);" id="slaask-send-input-trigger"  role="button" tabindex="0" aria-label="' + Wording.send_message + '"></div>'

    props.buttonPulsing = '';
    if (this.app._pulsing_enabled) {
      props.buttonPulsing   = '<div class="slaask-pulsing-button"><span><span></span></span></div>';
    }

    props.hideButtonClass = this.hide_slaask_button
                            ? "slaask-hidden"
                            : "";

    props.slaaskMiniClass = this.app._mini_widget
                            ? "slaask-mini"
                            : "";

    props.mobileClass = this.app.getScreenWidth() < this.app._mobile_threshold
                        ? "slaask-mobile"
                        : "";

    props.buttonSize = this.app._button_size;
    props.buttonSizeMargin = 20 * 2 + props.buttonSize;

    this.componentsProps = props;

    /* BUILD ELEMENTS */

    await this._loadParentCss();

    Utils.forEach(this._components, element => {
      this.preBuildComponent(element, props);
    });

    await this.get('button').buildIfNeeded();


    /* POST-INSERT EDIT */

    this.get('widget').when('ready').then(() => {
      Views.appendToDom();
      let input = this.findById('widget', 'slaask-input');
      input.setSelectionRange(input.value.length, input.value.length);

      this.switchFooter('footer');
      this.hideEmojiContainer();
      this.hideGifsContainer();

      this.get('widget').element.addEventListener('click', e => {
        if (e.target.tagName == "A" || e.target.tagName == "I") {
          if (Utils.closest(e.target, ".slaask-whitelabel")) {
            e.preventDefault();
            Views.jumpToViewByName('about');
          }
        }

        if (e.target.tagName == "A" || e.target.tagName == "I") {
          if (Utils.closest(e.target, ".slaask-ai-warning")) {
            e.preventDefault();
            Views.jumpToViewByName('ai-warning');
          }
        }
      });

      let slaaskEmojiImages = this.findAll('widget', '.slaask-emoji-image');
      for (let i = 0; i < slaaskEmojiImages.length; i++) {
        slaaskEmojiImages[i].addEventListener('click', () => {
          let value = this.findById('widget', 'slaask-input').value;
          if (value == '') {
            this.findById('widget', 'slaask-input').value = `:${slaaskEmojiImages[i].getAttribute('data-emoji-code')}:`
            Conversations.submitOnlineForm()
          } else {
            Utils.insertAtCaret(this.findById('widget', 'slaask-input'), slaaskEmojiImages[i].getAttribute('data-emoji'))
          }
          this.focusInput();
        }, false);
      }

      if (this.app._mini_widget) {
        this.get('widget').container.style.bottom    = (this.app._button_size + computedYOffset + this._offset_from_edge * 2) + 'px';
        this.get('widget').container.style.maxHeight = "calc(95% - " + this.get('widget').container.style.bottom + ")";
      }
    });

    this.get('message').when('ready').then(() => {
      this.get('message').container.style.bottom = (this.app._button_size + computedYOffset + this._offset_from_edge * 2) + "px";
    });


    /* END */

    // Show iframes back
    Utils.removeElement(cssHideIframesTag);

    this._trigger('ready');
    this._eventHappened('ready');
  }

  isInIframe() {
    return Utils.hasClass(document.body, 'slaask-iframe');
  }

  isInPopup() {
    return !!this.parent.asktechWidgetPopup;
  }

  addComponent(component) {
    this._components[component.name] = component;
  }

  // async appendComponentToDom(component, props) {
  //   component.attachSlaask(this.app);
  //   await component.buildElement({
  //     props: props,
  //     inIframe: this.app._in_iframe,
  //     externalCss: this._externalCss,
  //     additionalCss: this._externalCss ? "all" : this._css.all,
  //     customCss: this.customCss[component.name]
  //   });
  // }

  preBuildComponent(component, props) {
    component.attachSlaask(this.app);
    component.preBuildElement({
      props: props,
      inIframe: this.app._in_iframe,
      externalCss: this._externalCss,
      additionalCss: this._externalCss ? "all" : this._css.all,
      customCss: this.customCss[component.name]
    });
    component.when('ready').then(() => {
      component._applyOffsets();
    })
  }

  get(componentName) {
    return this._components[componentName];
  }

  /**
   * Iterates over windows of each component
   * If some components share the same window, it will only be fetched once
   * @param  {function}  handler
   * @param  {Boolean}   anticipated  See forEachWindowsAnticipated
   */
  forEachWindows(handler, anticipated = false) {
    let windows = [this.parent];
    let notReadyComponent = [];
    Utils.forEach(this._components, component => {
      if (component.isReady()) {
        let exists = !!~windows.indexOf(component.window);
        if (!exists) windows.push(component.window);
      }
      else if (anticipated) {
        component.when('ready').then(() => {
          let exists = !!~windows.indexOf(component.window);
          if (!exists) {
            windows.push(component.window);
            handler(component.window);
          }
        });
      }
    });
    Utils.forEach(windows, handler);
  }

  /**
   * Same as above, but iterates over non-existing yet windows
   * The handler is called asynchronously in that case
   */
  forEachWindowsAnticipated(handler) {
    this.forEachWindows(handler, true);
  }

  forEachComponents(handler) {
    Utils.forEach(this._components, component => {
      handler(component);
    });
  }

  _loadParentCss() {
    let promises = [];
    if (this._externalCss) {
      promises.push(Utils.loadCssFile(this.parent.document, this.getCssUrl("all")));
      promises.push(Utils.loadCssFile(this.parent.document, this.getCssUrl("positions")));
      promises.push(Utils.loadCssFile(this.parent.document, this.getCssUrl("parent")));
    }
    else {
      promises.push(Utils.appendCss(this.parent.document, this._css.all));
      promises.push(Utils.appendCss(this.parent.document, this._css.positions));
      promises.push(Utils.appendCss(this.parent.document, this._css.parent));
    }
    return Promise.all(promises);
  }

  // Same as _getCssUrl in Diagnosis.js
  getCssUrl(fileName) {
    return this.app._cdn_url + "/chat/css/" + fileName + ".min.css";
  }

  /* ALIAS */

  findById(componentName, id) {
    if (componentName == "parent")
      return this.parent.document.getElementById(id);
    else
      return this.get(componentName).findById(id);
  }

  find(componentName, selector) {
    if (componentName == "parent")
      return this.parent.document.querySelector(selector);
    else
      return this.get(componentName).find(selector);
  }

  findAll(componentName, selector) {
    if (componentName == "parent")
      return this.parent.document.querySelectorAll(selector);
    else
      return this.get(componentName).findAll(selector);
  }

  /**
   * addClass
   *
   * addClass(component, className)
   * addClass(component, selector, className)
   * addClass(component, null, className)
   *
   * @param {AbstractComponent} componentName   'widget', 'button', 'alert'... Can also be 'parent' for the parent window.
   * @param {string|Element} selector           CSS selector or HTML element where to add the class
   * @param {string} className                  Name of the class to add
   */
  addClass(componentName, selector, className) {
    if (componentName == "parent")
      return Utils.addClass(typeof selector == "string" ? this.parent.document.querySelectorAll(selector) : selector, className);
    else
      return this.get(componentName).addClass(selector, className);
  }

  /**
   * removeClass
   *
   * removeClass(component, className)
   * removeClass(component, selector, className)
   * removeClass(component, null, className)
   *
   * @param {AbstractComponent} componentName   'widget', 'button', 'alert'... Can also be 'parent' for the parent window.
   * @param {string|Element} selector           CSS selector or HTML element where to remove the class
   * @param {string} className                  Name of the class to remove
   */
  removeClass(componentName, selector, className) {
    if (componentName == "parent")
      return Utils.removeClass(typeof selector == "string" ? this.parent.document.querySelectorAll(selector) : selector, className);
    else
      return this.get(componentName).removeClass(selector, className);
  }

  hasClass(componentName, selector, className) {
    if (componentName == "parent")
      return Utils.hasClass(this.parent.document.querySelectorAll(selector), className);
    else
      return this.get(componentName).hasClass(selector, className);
  }

  /* DESTROY */

  destroy() {
    Utils.forEach(this._components, component => {
      component.destroy();
    });
    this._components = {};
    super.destroy();
  }

});
